import React, { useState } from "react";
import { portfolioProjects } from "../data/portfolioData";
import ProjectModal from "./ProjectModal";

function Portfolio() {
  const [selectedCategory, setSelectedCategory] = useState("All Projects (18+)");
  const [activeModalProject, setActiveModalProject] = useState(null);

  const categories = [
    "All Projects (18+)",
    "Enterprise BUMN & Fintech Apps",
    "Personal AI R&D & Local Automation",
    "Electrical, Mechanical & Embedded Hardware",
    "Academic, Client & Web Practice SPAs"
  ];

  const filteredProjects =
    selectedCategory === "All Projects (18+)"
      ? portfolioProjects
      : portfolioProjects.filter((project) => project.category === selectedCategory);

  return (
    <section
      id="portfolio"
      className="bg-slate-950 pt-32 pb-28 text-slate-100 relative overflow-hidden bg-cyber-grid"
    >
      <div className="container mx-auto px-4">
        <div className="w-full">
          <div className="mx-auto mb-14 max-w-2xl text-center">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-indigo-500/10 border border-indigo-500/30 text-indigo-400 font-mono text-xs font-bold uppercase tracking-widest mb-4">
              💻 FULL-STACK SOFTWARE PRODUCT GALLERY
            </div>
            <h2 className="mb-4 text-3xl font-black text-white sm:text-4xl lg:text-5xl tracking-tight">
              18+ Verified Web &amp; <span className="text-indigo-400">AI Software Systems</span>
            </h2>
            <p className="text-base font-normal text-slate-400 md:text-lg leading-relaxed">
              Featuring autonomous AI OS systems, enterprise BUMN portals, distributed microservices, and reactive full-stack web applications.
            </p>
          </div>
        </div>

        {/* Featured Stealth AI Agent Callout Banner */}
        <div className="mb-14 mx-auto max-w-5xl rounded-3xl bg-gradient-to-r from-slate-900 via-indigo-950 to-slate-900 border border-indigo-500/40 p-6 md:p-8 text-white shadow-2xl relative overflow-hidden animate-pulse-indigo">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-6 relative z-10">
            <div className="max-w-xl">
              <span className="px-3 py-1 rounded-full bg-emerald-500/20 border border-emerald-400/40 text-emerald-400 font-mono text-[10px] font-bold uppercase tracking-widest mb-2 inline-block">
                🚀 FEATURED PRODUCTION OS :: MY AGENT
              </span>
              <h3 className="text-2xl font-black font-mono text-white mb-2">
                My Agent — Autonomous Career &amp; Personal Brand OS
              </h3>
              <p className="text-xs text-slate-300 leading-relaxed font-mono">
                Full-stack autonomous AI copilot system powered by Next.js 16, React 19, Puppeteer ATS auto-tailoring, live Markdown preview, and multi-key load balancing failovers.
              </p>
            </div>
            <a
              href="https://my-agent-mauve-omega.vercel.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-3.5 rounded-2xl bg-indigo-500 hover:bg-indigo-400 text-white font-mono font-bold text-xs uppercase tracking-wider shadow-lg shadow-indigo-500/30 transition-all duration-300 hover:scale-105 shrink-0 text-center"
            >
              🚀 Launch My Agent Live Portal
            </a>
          </div>
        </div>

        {/* Category Filter Pills */}
        <div className="mb-14 flex flex-wrap justify-center gap-3">
          {categories.map((cat) => (
            <button
              key={cat}
              type="button"
              onClick={() => setSelectedCategory(cat)}
              className={`rounded-2xl px-5 py-3 font-mono text-xs font-bold transition-all duration-300 ${
                selectedCategory === cat
                  ? "bg-indigo-500 text-white shadow-lg shadow-indigo-500/30 scale-105"
                  : "bg-slate-900 border border-slate-800 text-slate-400 hover:text-white"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProjects.map((project) => (
            <div
              key={project.id}
              className="cyber-card group flex flex-col justify-between rounded-3xl p-6 transition-all duration-300"
            >
              <div>
                <div className="flex items-center justify-between gap-2 mb-4">
                  <span className="px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/30 text-indigo-400 font-mono text-[10px] font-bold uppercase">
                    {project.category}
                  </span>
                  {project.link || project.liveUrl ? (
                    <span className="inline-flex items-center gap-1.5 text-[10px] font-mono font-bold text-emerald-400">
                      <span className="h-2 w-2 rounded-full bg-emerald-500 animate-ping" />
                      Live Portal
                    </span>
                  ) : (
                    <span className="text-[10px] font-mono text-slate-500">
                      🔒 Protected
                    </span>
                  )}
                </div>

                <h3 className="text-xl font-extrabold text-white mb-3 group-hover:text-indigo-400 transition-colors font-mono">
                  {project.title}
                </h3>

                <p className="text-xs text-slate-300 leading-relaxed mb-6 font-normal">
                  {project.shortDesc || project.description}
                </p>

                {/* Tech Tags */}
                <div className="flex flex-wrap gap-1.5 mb-6">
                  {(project.techStack || project.tags || ["TypeScript", "Next.js", "Node.js"]).map((tech, idx) => (
                    <span key={idx} className="px-2.5 py-1 rounded-md bg-slate-950 border border-slate-800 text-slate-300 font-mono text-[10px]">
                      {tech}
                    </span>
                  ))}
                </div>
              </div>

              <div className="flex items-center gap-2 pt-2">
                <button
                  type="button"
                  onClick={() => setActiveModalProject(project)}
                  className="flex-1 py-3 rounded-xl bg-slate-950 hover:bg-indigo-500 hover:text-white border border-indigo-500/30 font-mono font-bold text-xs uppercase tracking-wider text-indigo-400 transition-all duration-300 flex items-center justify-center gap-1.5"
                >
                  <span>🔍 Inspect Code</span>
                </button>
                {(project.link || project.liveUrl) && (
                  <a
                    href={project.link || project.liveUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-3 rounded-xl bg-indigo-500 hover:bg-indigo-400 text-white font-bold transition-all shadow-md"
                    title="Launch Live Portal"
                  >
                    🚀
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Interactive Modal */}
      {activeModalProject && (
        <ProjectModal
          project={activeModalProject}
          onClose={() => setActiveModalProject(null)}
        />
      )}
    </section>
  );
}

export default Portfolio;
